// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* QR code section styles. */

.profile__qr-code {
  --qrcode-card-gap: var(--spacing-md, 1.25rem);
  --qrcode-card-caption-color: var(--color-text-strong-secondary, var(--gray-800, #1E2939));
  --qrcode-card-caption-size: var(--font-size-md, 1rem);
  --qrcode-card-caption-size-compact: var(--font-size-sm, 0.875rem);
  --qrcode-card-caption-weight: var(--font-weight-md, 500);
  --qrcode-card-image-padding-top: 1rem;
  --qrcode-card-image-padding-right: 1rem;
  --qrcode-card-image-padding-bottom: 1.0625rem;
  --qrcode-card-image-padding-left: 1.0625rem;
  --qrcode-card-frame-border: var(--border-width-thin, 0.1rem) solid var(--color-border, var(--gray-200, #E5E7EB));
  --qrcode-card-frame-background: var(--color-surface-framed-content, #F3F4F6);
  --qrcode-section-padding-compact: var(--spacing-sm, 0.938rem);
  --qrcode-section-gap-compact: var(--spacing-2xs, 0.625rem);
  border-radius: var(--border-radius-base, 0.3125rem);
  background: var(--color-card-bg, var(--white, #FFF));
  border: var(--border-width-thin, 0.1rem) solid var(--color-border-lighter, #E2E8F0);
}

/* Caption */
.qrcode-card__caption {
  text-align: center;
  margin: 0;
  color: var(--qrcode-card-caption-color);
  font-size: var(--qrcode-card-caption-size);
  font-weight: var(--qrcode-card-caption-weight);
}

/* Card and frame */
.qrcode-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--qrcode-card-gap);
  align-self: stretch;
}

.qrcode-card__frame {
  margin: 0;
  padding:
    var(--qrcode-card-image-padding-top)
    var(--qrcode-card-image-padding-right)
    var(--qrcode-card-image-padding-bottom)
    var(--qrcode-card-image-padding-left);
  border-radius: var(--border-radius-base, 0.3125rem);
  border: var(--qrcode-card-frame-border);
  background: var(--qrcode-card-frame-background);
}

/* QR image */
.qrcode-card__image {
  flex-shrink: 0;
  aspect-ratio: 1/1;
}

.qrcode-card__image svg {
  width: 100%;
  height: 100%;
  display: block;
}

/* Compact layout */
:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .profile__qr-code {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  padding: var(--qrcode-section-padding-compact);
  gap: var(--qrcode-section-gap-compact);
}

@container profile-pane (max-width: 576px) {
  .profile__qr-code {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    align-self: stretch;
    padding: var(--qrcode-section-padding-compact);
    gap: var(--qrcode-section-gap-compact);
  }
}

:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .qrcode-card__caption {
  font-size: var(--qrcode-card-caption-size-compact);
}

@media (max-width: 576px) {
  .profile__qr-code {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    align-self: stretch;
    padding: var(--qrcode-section-padding-compact);
    gap: var(--qrcode-section-gap-compact);
  }

  .qrcode-card__caption {
    font-size: var(--qrcode-card-caption-size-compact);
  }
}

@container profile-pane (max-width: 576px) {
  .qrcode-card__caption {
    font-size: var(--qrcode-card-caption-size-compact);
  }
}`, "",{"version":3,"sources":["webpack://./node_modules/profile-pane/lib/sections/qrcode/QRCodeSection.css"],"names":[],"mappings":"AAAA,4BAA4B;;AAE5B;EACE,6CAA6C;EAC7C,yFAAyF;EACzF,qDAAqD;EACrD,iEAAiE;EACjE,wDAAwD;EACxD,qCAAqC;EACrC,uCAAuC;EACvC,6CAA6C;EAC7C,2CAA2C;EAC3C,gHAAgH;EAChH,4EAA4E;EAC5E,6DAA6D;EAC7D,0DAA0D;EAC1D,mDAAmD;EACnD,oDAAoD;EACpD,mFAAmF;AACrF;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,SAAS;EACT,uCAAuC;EACvC,0CAA0C;EAC1C,8CAA8C;AAChD;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT;;;;yCAIuC;EACvC,mDAAmD;EACnD,uCAAuC;EACvC,+CAA+C;AACjD;;AAEA,aAAa;AACb;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,8CAA8C;EAC9C,sCAAsC;AACxC;;AAEA;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,8CAA8C;IAC9C,sCAAsC;EACxC;AACF;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,8CAA8C;IAC9C,sCAAsC;EACxC;;EAEA;IACE,kDAAkD;EACpD;AACF;;AAEA;EACE;IACE,kDAAkD;EACpD;AACF","sourcesContent":["/* QR code section styles. */\n\n.profile__qr-code {\n  --qrcode-card-gap: var(--spacing-md, 1.25rem);\n  --qrcode-card-caption-color: var(--color-text-strong-secondary, var(--gray-800, #1E2939));\n  --qrcode-card-caption-size: var(--font-size-md, 1rem);\n  --qrcode-card-caption-size-compact: var(--font-size-sm, 0.875rem);\n  --qrcode-card-caption-weight: var(--font-weight-md, 500);\n  --qrcode-card-image-padding-top: 1rem;\n  --qrcode-card-image-padding-right: 1rem;\n  --qrcode-card-image-padding-bottom: 1.0625rem;\n  --qrcode-card-image-padding-left: 1.0625rem;\n  --qrcode-card-frame-border: var(--border-width-thin, 0.1rem) solid var(--color-border, var(--gray-200, #E5E7EB));\n  --qrcode-card-frame-background: var(--color-surface-framed-content, #F3F4F6);\n  --qrcode-section-padding-compact: var(--spacing-sm, 0.938rem);\n  --qrcode-section-gap-compact: var(--spacing-2xs, 0.625rem);\n  border-radius: var(--border-radius-base, 0.3125rem);\n  background: var(--color-card-bg, var(--white, #FFF));\n  border: var(--border-width-thin, 0.1rem) solid var(--color-border-lighter, #E2E8F0);\n}\n\n/* Caption */\n.qrcode-card__caption {\n  text-align: center;\n  margin: 0;\n  color: var(--qrcode-card-caption-color);\n  font-size: var(--qrcode-card-caption-size);\n  font-weight: var(--qrcode-card-caption-weight);\n}\n\n/* Card and frame */\n.qrcode-card {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: var(--qrcode-card-gap);\n  align-self: stretch;\n}\n\n.qrcode-card__frame {\n  margin: 0;\n  padding:\n    var(--qrcode-card-image-padding-top)\n    var(--qrcode-card-image-padding-right)\n    var(--qrcode-card-image-padding-bottom)\n    var(--qrcode-card-image-padding-left);\n  border-radius: var(--border-radius-base, 0.3125rem);\n  border: var(--qrcode-card-frame-border);\n  background: var(--qrcode-card-frame-background);\n}\n\n/* QR image */\n.qrcode-card__image {\n  flex-shrink: 0;\n  aspect-ratio: 1/1;\n}\n\n.qrcode-card__image svg {\n  width: 100%;\n  height: 100%;\n  display: block;\n}\n\n/* Compact layout */\n:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .profile__qr-code {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  align-self: stretch;\n  padding: var(--qrcode-section-padding-compact);\n  gap: var(--qrcode-section-gap-compact);\n}\n\n@container profile-pane (max-width: 576px) {\n  .profile__qr-code {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    align-self: stretch;\n    padding: var(--qrcode-section-padding-compact);\n    gap: var(--qrcode-section-gap-compact);\n  }\n}\n\n:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .qrcode-card__caption {\n  font-size: var(--qrcode-card-caption-size-compact);\n}\n\n@media (max-width: 576px) {\n  .profile__qr-code {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    align-self: stretch;\n    padding: var(--qrcode-section-padding-compact);\n    gap: var(--qrcode-section-gap-compact);\n  }\n\n  .qrcode-card__caption {\n    font-size: var(--qrcode-card-caption-size-compact);\n  }\n}\n\n@container profile-pane (max-width: 576px) {\n  .qrcode-card__caption {\n    font-size: var(--qrcode-card-caption-size-compact);\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
